export default __webpack_public_path__ + "static/media/javascript.9abe85eb.svg";